import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-our-deposits-modal',
  templateUrl: './our-deposits-modal.component.html',
  styleUrls: ['./our-deposits-modal.component.scss'],
  standalone: true,
  imports: [SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class OurDepositsModalComponent {}
